import { render, staticRenderFns } from "./OutOfStockAlerts.vue?vue&type=template&id=0b7849d8&"
import script from "./OutOfStockAlerts.vue?vue&type=script&lang=js&"
export * from "./OutOfStockAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports